interface SocketConfig {
    reconnectionDelay: number;
    reconnectionDelayMax: number;
    reconnectionAttempts: number;
    timeout: number;
}

const configs: Record<string, SocketConfig> = {
    test: {
        reconnectionDelay: 1000,
        reconnectionDelayMax: 10000,
        reconnectionAttempts: 10,
        timeout: 20000,
    },

    development: {
        reconnectionDelay: 1000,
        reconnectionDelayMax: 10000,
        reconnectionAttempts: 10,
        timeout: 20000,
    },

    production: {
        reconnectionDelay: 1000,
        reconnectionDelayMax: 10000,
        reconnectionAttempts: 10,
        timeout: 20000,
    },
};

export const getSocketConfig = (): SocketConfig => {
    const env = process.env.NODE_ENV || 'development';

    if (process.env.REACT_APP_TEST_MODE === 'true') {
        return configs.test;
    }

    return configs[env] || configs.development;
};

export default getSocketConfig;